import { Box, keyframes, styled } from '@mui/material';

export const ImagesContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(22.5),
  display: 'flex',
  aspectRatio: '1 / 1',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    maxWidth: theme.spacing(17),
  },
}));

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const ImagesSkeleton = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  background: theme.palette.grey[700],
}));

export const SingleImage = styled('img')(({ theme }) => ({
  width: '100%',
  animationName: fadeIn,
  animationDuration: '2s',
  background: theme.palette.grey[700],
}));

export const ResultImages = styled(ImagesContainer)(({ theme }) => ({
  overflow: 'initial',
  animationName: fadeIn,
  animationDuration: '1s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  borderRadius: '50%',
  border: '2px solid',
  borderColor: theme.palette.grey[50],
  [theme.breakpoints.down('md')]: {
    minWidth: theme.spacing(17),
  },
}));

const ResultsImage = styled('img')(() => ({
  position: 'absolute',
  width: '80%',
}));

export const TopImage = styled(ResultsImage)(({ theme }) => ({
  left: theme.spacing(-0.25),
  top: theme.spacing(-0.25),
}));

export const BottomImage = styled(ResultsImage)(({ theme }) => ({
  right: theme.spacing(-0.25),
  bottom: theme.spacing(-0.25),
}));
